<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <span>

      <button
        v-if="params.data.switchboard != null"
        class="p-2 mr-1"
        v-bind:class=" { 'tps-registered' : params.data.switchboard_checked_status == 'Registered' }"
        @click="dialNumber('switchboard')"
      >
       <span v-bind:class=" { 'tps-register' : params.data.switchboard_checked_status == 'Registered' }">
        S  
       </span>
       
      </button>

      <button
        v-if="params.data.site_switchboard != null"
        class="p-2 mr-1"
        v-bind:class=" { 'tps-registered' : params.data.site_switchboard_checked_status == 'Registered' }"
        @click="dialNumber('site_switchboard')"
        
      >
      <span v-bind:class=" { 'tps-register' : params.data.site_switchboard_checked_status == 'Registered' }">
        SS
       </span>
      </button>

      <button
        v-if="params.data.contact_ddi && params.data.contact_ddi.length != 0"
        class="p-2 mr-1"
        v-bind:class=" { 'tps-registered' : params.data.contact_ddi.some(d => d.checked_status == 'Registered')}"
        @click="dialNumber('ddi')"
      >

      <span v-bind:class=" { 'tps-register' : params.data.contact_ddi.some(d => d.checked_status == 'Registered')}"
>        DDI
       </span>

        
      </button>
      <vs-icon
        v-if="params.data.contact_ddi && params.data.contact_ddi.length > 1"
        style="border:1px solid;"
        class="mr-3"
        @click="showDDIs('ddi')"
        icon="arrow_downward"
      ></vs-icon>

      <button
        v-if="params.data.contact_mobile && params.data.contact_mobile.length != 0"
        v-bind:class=" { 'tps-registered' : params.data.contact_mobile.some(mob => mob.checked_status == 'Registered')}"
        class="p-2 mr-1"
        @click="dialNumber('mobile')"
      >
      <span v-bind:class=" { 'tps-register' : params.data.contact_mobile.some(mob => mob.checked_status == 'Registered')}"
>
        Cell
       </span>
        
      </button>
      <vs-icon
        v-if=" params.data.contact_mobile && params.data.contact_mobile.length > 1"
        style="border:1px solid;"
        class="mr-3"
        @click="showMobiles('mobile')"
        icon="arrow_downward"
      ></vs-icon>
      <button
        v-if="params.data.account_phone && params.data.account_phone.length != 0"
        v-bind:class=" { 'tps-registered' : params.data.account_phone.some(ph => ph.checked_status == 'Registered')}"

        class="p-2 mr-1"
        @click="dialNumber('other')"
      >

      <span v-bind:class=" { 'tps-register' : params.data.account_phone.some(ph => ph.checked_status == 'Registered')}"
>
Other
       </span>
        
      </button>
      
      
      <vs-icon
        v-if="params.data.account_phone && params.data.account_phone.length > 1"
        style="border:1px solid;"
        class="mr-3"
        @click="showOther('other')"
        icon="arrow_downward"
      ></vs-icon>
    </span>
  </div>
</template>

<script>
import axios from "@/axios.js";
export default {
  name: "CellRendererButtons",
  data() {
    return {
      selected_account: null,
      sdContactClickEventConId: null,
    };
  },
  methods: {
    showSwitchboards(type) {
      let newObj = {};
      newObj.type = type;
      newObj.params = this.params;
      newObj.data = this.params.data;
      this.$parent.$parent.showDialPopup(newObj);
      console.log("Buttons" , this.params.data.account_id);
      this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);

    },
    showSiteSwitchboards(type) {
      let newObj = {};
      newObj.type = type;
      newObj.params = this.params;
      newObj.data = this.params.data;
      this.$parent.$parent.showDialPopup(newObj);
      this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);

    },
    showDDIs(type) {
      let newObj = {};
      newObj.type = type;
      newObj.params = this.params;
      newObj.data = this.params.data;
      this.$parent.$parent.showDialPopup(newObj);
      this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);

    },
    dialNumber(type) {
      let self = this;
      let newObj = {};
      newObj.type = type;
      newObj.params = this.params;
      newObj.data = this.params.data;



      let countNumbers = 0;

      if (type != "switchboard" || type != "site_switchboard") {
        if (type == "ddi") {
          countNumbers = this.params.data.contact_ddi.length;
        }
        if (type == "mobile") {
          countNumbers = this.params.data.contact_mobile.length;
        }
        if (type == "other") {
          countNumbers = this.params.data.account_phone.length;
        }
        if (countNumbers > 1) {
          if (type == "ddi") {
            newObj.data.contact_ddi.map(function(ele) {
              if (ele.is_primary == true) {
                newObj.data.contact_ddi = newObj.data.contact_ddi.filter(
                  element => element.is_primary == true
                );

                self.$parent.$parent.dialNumber(newObj);
              } else {
                return false;
              }
            });
          }

          if (type == "mobile") {
            newObj.data.contact_mobile.map(function(ele) {
              if (ele.is_primary == true) {
                newObj.data.contact_mobile = newObj.data.contact_mobile.filter(
                  element => element.is_primary == true
                );

                self.$parent.$parent.dialNumber(newObj);
              } else {
                return false;
              }
            });
          }

          if (type == "other") {
            return false;
          }

          return false;
        } else {
          this.$parent.$parent.dialNumber(newObj);
        }
      } else {
        this.$parent.$parent.dialNumber(newObj);
      }

      this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);

    },
    showMobiles(type) {
      let newObj = {};
      newObj.type = type;
      newObj.data = this.params.data;
      newObj.params = this.params;
      this.$parent.$parent.showDialPopup(newObj);
      this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);
    },
    showOther(type) {
      let newObj = {};
      newObj.type = type;
      newObj.params = this.params;
      newObj.data = this.params.data;
      this.$parent.$parent.showDialPopup(newObj);
      this.$parent.$parent.showContactsFieldsWithContactID(this.params.data.new_contact_id , this.params.data.account_id);
    }
  },
  beforeMount() {},
  created() {},
  mounted() {
    // console.log("sdfsdfsdfsdf" , this.params.data);
  }
};
</script>


